module.exports = __webpack_public_path__ + "img/9788936456757.0549ddda.jpg";